import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../Layout/Layout";
// import Footer from "../../Layout/Footer";
// import FooterCalendar from "../../Layout/FooterCalendar";
import FooterNew from "../../Layout/FooterNew";

const BASE_URL = "https://ecom.cyberathon.com";

const Blog1 = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/index.php/Api/list_blog`);
      if (res.data.status) {
        setBlogs(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  return (
    <>
    <Layout/>
      <div className="container mb-4 blog-events py-5">
        <h1 className="fw-bold d-flex justify-content-center align-items-center mb-4 hh">
          Blog
        </h1>

        <div className="row justify-content-center">
          {blogs.map((item) => (
            <div
              className="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-4"
              key={item.id}
            >
              <div className="boxes mb-5">
                <img
                  src={`${BASE_URL}/${item.image}`}
                  className="w-100 imgsss"
                  alt={item.heading}
                />
                <h2 className="text-center hhh ">{item.heading}</h2>
                <p className="pp">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
      {/* <Footer/> */}
      {/* <FooterCalendar/> */}
      <FooterNew/>
    </>
  );
};

export default Blog1;
